<template>
  <!--eslint-disable-->
  <ConstructorElement
    :style="cssStyle"
    :componentId="componentId"
    :componentType="componentType"
    @click.native="onConstructorElemenClick"
    @mousedown.native="onConstructorElementMouseDown"
  />
</template>

<script>
import constructorSelectedMixin, { SELECTED_CSS_CLASS, LAST_SELECTED_CSS_CLASS } from '../mixins/constructorSelected';

export default {
  mixins: [constructorSelectedMixin],
  props: {
    componentId: String,
    componentType: String,
    cssStyle: Object
  },
  watch: {
    constructorElementSelected() {
      this.$el.parentElement.classList.toggle(SELECTED_CSS_CLASS);
    },
    constructorElementLastSelected() {
      this.$el.parentElement.classList.toggle(LAST_SELECTED_CSS_CLASS);
    }
  }
};
</script>
